module.exports = __webpack_public_path__ + "static/media/icon-outline-credit-card-blue.b11d991a.svg";